import gtm from 'src/components/google-gtm'

export default ({ router }) => {
  router.afterEach((to, from) => {
    // let dados = { 'page_path': to.path.split('?')[0] }
    gtm.logPage(to.path.split('?')[0])
  })
}
